// src/Pages/Main.jsx                                       //
import { useEffect, useState, useCallback, useRef } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { isRouteAllowed } from "./components/allowedRoutePrefixes";
import InvalidRequestPage from "./components/InvalidRequestPage";
import { useAuth } from "./context/AuthContext";
import axios from "axios";
import { Box, Snackbar, Alert, Button, Typography, Slide, CircularProgress } from "@mui/material";
import { WifiOff } from "@mui/icons-material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { motion, AnimatePresence } from "framer-motion";
import InquiryForm_v1 from "./Pages/inquiryForm_v1.jsx";
import InquiryDetails_v1 from "./Pages/InquiryDetails_v1.jsx";
import FollowUpPage_v1 from "./Pages/FollowUpPagev1.jsx";
import UserDetailsPage_v1 from "./Pages/UserDetailsPagev1.jsx";
import UserMaster_v1 from "./Pages/UserMaster_v1.jsx";
import TeamLeaderDetails_v1 from "./Pages/TeamLeaderDetails_v1.jsx";
import TeamDetails_v1 from "./Pages/TeamDetails_v1.jsx";
// Layout Components
import Navigation from "./components/Navigation";
// Page Components
import Home2 from "./Pages/Home2";
import FollowUpPage from "./Pages/FollowUpPage";
import InquiryForm from "./Pages/InquiryForm";
import UserMaster from "./Pages/UserMaster";
import ChangePassword from "./Pages/ChangePassword";
import InquiryDetails from "./Pages/InquiryDetails";
import InquiryDetailsV4 from "./Pages/InquiryDetailsV4.jsx";
import UserDetailsPage from "./Pages/UserDetailsPage";
import TeamDetails from "./Pages/TeamDetails";
import TeamLeaderDetails from "./Pages/TeamLeaderDetails";
import ReassignInquiryDetails from "./Pages/ReassignInquiryDetails";
import ComplainDetails from "./Pages/ComplainDetail";
import ComplainForm from "./Pages/ComplainForm";
import ComplainFollowUp from "./Pages/ComplainFollowUp";
import ComplainFollowUpVersion2 from "./Pages/ComplainFollowUpVersion2.jsx";
import ReAssignComplaintDetails from "./Pages/ReAssignComplaintDetails";
// Key Management
import KeyOptions from "./Pages/KeyOption.js";
import GenerateKey from "./Pages/GenerateKey.js";
import FileUpload from "./Pages/FileUpload.jsx";
import InsertClientData from "./Pages/InsertClientData.jsx";
// Payment & Finance
import SuccessFollowupPage from "./Pages/PaymentFollowupPage";
import SaleInvoice from "./Pages/SaleInvoice";
import CreditNote from "./Pages/CreditNoteDetails";
import CreditNotev2 from "./Pages/CreditNotev2.jsx";
// Client Management
import ClientDetail from "./Pages/ClientDetail";
import ClientMaster from "./Pages/ClientMaster";
import ClientMasterWrapper from "./Pages/ClientMasterWrapper.jsx";
import ClientDetail2 from "./Pages/ClientDetail2.jsx";
import AccGrpDetails from "./Pages/AccGrpDetails.jsx";
import AccGrpMaster from "./Pages/AccGrpMaster.jsx";
import InsertClient from "./Pages/InsertClient.jsx";
import ConsigneeDetails from "./Pages/ConsigneeDetails.jsx";
import ConsigneeMaster from "./Pages/ConsigneeMaster.jsx";
import ConsigneeDetails2 from "./Pages/ConsigneeDetails2.jsx";
// Currency Management
import CurrencyDetail from "./Pages/CurrencyDetail";
import CurrencyMaster from "./Pages/CurrencyMaster";
import CurrencyDetail2 from "./Pages/CurrencyDetail2.jsx";
// Quotation Management
import QuotationDetail from "./Pages/QuotationDetail";
// import QuotationMaster from "./Pages/QuotationMaster";
import GoDownDetail from "./Pages/GoDownDetail.jsx";
import GodownMaster from "./Pages/GodownMaster.jsx";
import HsnDetail from "./Pages/HsnDetail.jsx";
import HsnMaster from "./Pages/HsnMaster.jsx";
import UnitDetail from "./Pages/UnitDetail.jsx";
import UnitMaster from "./Pages/UnitMaster.jsx";
import ProdGroupDetail from "./Pages/ProdGroupDetail.jsx";
import ProGroupMaster from "./Pages/ProGroupMaster.jsx";
import ProdGroupDetail2 from "./Pages/ProdGroupDetails2.jsx";
import ProductDetail from "./Pages/ProductDetail.jsx";
import ProductMaster from "./Pages/ProductMaster.jsx";
import ProductDetail2 from "./Pages/ProductDetail2.jsx";
import MultiLevelBOMForm from "./Pages/MultiLevelBOMForm.jsx";
import OrderDetails from "./Pages/orderDetails.jsx";
import OrderDetails_v2 from "./Pages/OrderDetailsV2.jsx";
import { CartProvider } from './context/CartContext';
import CartPage from './Pages/CartPage.jsx';
import CheckoutPage from './Pages/CheckoutPage';
import OrderConfirmation from './Pages/OrderConfirmation'; // brief page to show ID
import MyOrders from "./Pages/MyOrders.jsx";
import ViewOrderPage from "./Pages/ViewOrderPage.jsx";
import OrdersAdmin from "./Pages/OrderAdmin.jsx";
// Order Stepper
import OrderDetail from "./Pages/Order_Stepper/Detail.jsx";
import OrderMaster from "./Pages/Order_Stepper/Master.jsx";
//Challan Stepper
import ChallanMaster from "./Pages/Challan_Stepper/Master.jsx";
// Invoice Stepper
import InvoiceMaster from "./Pages/Invoice_Steeper/Master.jsx";
import DispatchPage from "./Pages/DispatchPage.jsx";
import { DispatchProvider } from './context/DispatchContext';
import DispatchCart from "./Pages/DispatchCart.jsx";
import SaleInvoice_v2 from "./Pages/SaleInvoice_v2.jsx";
import SaleInvoicePrevFY from "./Pages/SaleInvoicePrevFY.jsx";
import PriceListMaster from "./Pages/PriceListMaster.jsx";

//Proforma Invoice Module
import ProformaInvoiceDetails from "./Pages/ProformaInvoice_Stepper/ProformaInvoiceDetails.jsx"
import ProformaInvoiceMaster from "./Pages/ProformaInvoice_Stepper/ProformaInvoiceMaster.jsx"
// Inquiry Master Module
import QuotationMaster from "./Pages/EnquiryModule_v1/InquiryMaster.jsx";
import InquiryDetail from "./Pages/EnquiryModule_v1/InquiryDetail.jsx";
import ReAssignInquiryDetails2 from "./Pages/ReAssignInquiryDetails2.jsx";
import SaleInvoice3 from "./Pages/SaleInvoice2.jsx";
import UserDetailsPage_v3 from "./Pages/UserDetailsPage_v3.jsx";
import TeamLeaderDetails_v3 from "./Pages/TeamLeaderDetailsv3.jsx";
import FollowUpPageV3 from "./Pages/FollowUpPageV3.jsx";
import CompanyDetail from "./Pages/CompanyDetail.jsx";
import CompanyMaster from "./Pages/CompanyMaster.jsx";
import Payable from "./Pages/Payable/Payable.jsx";
import Vouchers from "./Pages/Payable/Vouchers.jsx";
// Purchase Order
import PurchaseOrderDetails from "./Pages/purchase_Order/Purchase_OrderDetail.jsx";
import PurchaseOrderMaster from "./Pages/purchase_Order/PurchaseOrderMaster.jsx";
// Purchase Challan
import PurcDispatchDetails from "./Pages/purchase_Dispatch/PurcDispatchDetails.jsx";
import PurcDispatchMaster from "./Pages/purchase_Dispatch/PurcDispatchMaster.jsx";
// Purchase Invoice
import PurchaseInvoiceDetails from "./Pages/Purchase_Invoice/PurchaseInvoiceDetails.jsx";
import PurcInvoiceMaster from "./Pages/Purchase_Invoice/PurcInvoiceMaster.jsx";

// Credit Note
import CreditNoteDetails from "./Pages/CreditNote Module/CreditNoteDetails.jsx";
import CreditNoteMaster from "./Pages/CreditNote Module/CreditNoteMaster.jsx";

// Debit Note
import DebitNoteDetails from "./Pages/DebitNote Module/DebitNoteDetails.jsx";
import DebitNoteMaster from "./Pages/DebitNote Module/DebitNoteMaster.jsx";
// 
import OrderTestMaster from "./Pages/Test/OrderTestMaster.jsx";
import InsertProduct from "./Pages/InsertProduct.jsx";
// Candidate Management
import CandidateMaster from "./Pages/HR_Stepper/CandidateMaster.jsx";
import CandidateDetails from "./Pages/HR_Stepper/CandidateDetails.jsx";
import InsertCandidates from "./Pages/InsertCandidates.jsx";
import PrintingUtilities from "./Pages/PrintingUtilities.jsx";
import { Navigate } from "react-router-dom";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

// Task
import TaskDetail from "./Pages/TaskDetail.jsx";
import TaskMaster from "./Pages/TaskMaster.jsx";
import TaskReAssign from "./Pages/TaskReAssign.jsx";
import PayableV2 from "./Pages/Payable/PayableV2.jsx";
import { NotificationProvider } from "./context/NotificationContext.js";

import EwayBill from "./Pages/EwayBill.jsx";
import EInvoice from "./Pages/EInvoice.jsx";
import SeriesMaster from "./Pages/SeriesMaster.jsx";
import StoreDetails from "./Pages/Store/StoreDetails.jsx";
import StoreMaster from "./Pages/Store/StoreMaster.jsx";
import LedgerDetails from "./Pages/LedgerDetails.js";
import StockReport from "./Pages/StockReport.js";
import MISReport from "./Pages/MISReports.js";
import MISPurchaseReport from "./Pages/MISPurchaseReports.js";
import AccountReports from "./Pages/AccountReports.js"
import ConsignerMaster from "./Pages/ConsignerMaster.jsx";
import OSandODSaleReport from "./Pages/OSandODSaleReport.js";
import OSandODPurcReport from "./Pages/OSandODPurcReport.js";
import OSandODBillsReport from "./Pages/OSandODBillsReport.js";
import BankCashPosting from "./Pages/BankCashPosting.jsx";

import Receiveable from "./Pages/Receivable/Receiveable";
import ReceiveableV2 from "./Pages/Receivable/ReceiveableV2.jsx";
import VoucherDetails from "./Pages/Payable/VoucherDetails.jsx";
import ReceivableDetails from "./Pages/Receivable/ReceivableDetails.jsx";
import PayableDetails from "./Pages/Payable/PayableDetails.jsx";
import ConfigureModule from "./Pages/ConfigureModule.jsx";
import UserDefineColumns from "./Pages/UserDefineColumns.jsx";
import UserDefineCharges from "./Pages/UserDefineCharges.jsx";

export default function Main({ connectionString, pdfString, appVersion }) {
  const [companySwitchLoading, setCompanySwitchLoading] = useState(true);
  const [isOnline, setIsOnline] = useState(true);
  const [isSlow, setIsSlow] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [retryIn, setRetryIn] = useState(10);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // Strip the "/main" prefix so it matches allowedRoutePrefixes' bare paths
  // (e.g. "/main/company" -> "/company").
  const routeAllowed = isRouteAllowed(location.pathname.replace(/^\/main/, "") || "/home");
  // ✅ Track previous selectedCompany to only trigger on actual company SWITCH
  const prevCompanyRef = useRef(null);
  const isFirstRender = useRef(true);  // ← NEW: guards the first mount

  // NEW: Get everything from AuthContext
  const { user, companyData, selectedCompany, logout, loading, triggerLogout } = useAuth();

  const path = connectionString;

  useEffect(() => {
    if (!user) return;
    if (window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: "USER_LOGIN", userId: user.UserId }));
    }
  }, [user]);

  useEffect(() => {
    if (loading) return;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      prevCompanyRef.current = selectedCompany;
      setCompanySwitchLoading(false);
      return;
    }

    if (prevCompanyRef.current !== selectedCompany) {
      setCompanySwitchLoading(true);
      prevCompanyRef.current = selectedCompany;
      const timer = setTimeout(() => setCompanySwitchLoading(false), 600);
      return () => clearTimeout(timer);
    }
  }, [selectedCompany, loading]);

  useEffect(() => {
    const handler = (event) => {
      const data = event.data;
      if (!data || data.type !== "PUSH_NOTIFICATION") return;
      const payload = data.payload;
      if (!payload?.screen) return;
      if (payload.screen === "InquiryDetails") {
        navigate("/main/v4/inquiry-details");
      } else if (payload.screen === "Invoice") {
        navigate("/main/v2/sale-invoice");
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [navigate]);

  // ─── DEFENSE-IN-DEPTH: Validate ALL route changes, including direct navigation ────────
  // This catches any window.location.href bypasses and enforces the allowlist everywhere.
  useEffect(() => {
    const validateRouteOnChange = () => {
      const currentPath = location.pathname.replace(/^\/main/, "") || "/home";
      const isAllowed = isRouteAllowed(currentPath);

      if (!isAllowed) {
        console.warn(`⚠️ Blocked unauthorized route access: ${location.pathname}`);
        navigate("/main/home", { replace: true });
      }
    };

    // Check immediately when location changes (catches navigate() and manual assignments)
    validateRouteOnChange();
  }, [location.pathname, navigate]);

  const handleLogout = () => {
    triggerLogout();
  };

  // ─── ALL HOOKS MUST BE HERE (before any return) ─────────────────────
  const checkConnection = useCallback(async () => {
    const start = Date.now();
    try {
      await axios.get(`${path}/api/ping`, { timeout: 10000 });
      const duration = Date.now() - start;
      setIsOnline(true);
      setIsSlow(duration > 10000);
      setSnackbarOpen(duration > 10000);
    } catch {
      setIsOnline(false);
      setIsSlow(false);
    }
  }, [path]);

  useEffect(() => {
    let cancelled = false;
    const loop = async () => {
      while (!cancelled) {
        await checkConnection();
        await new Promise(r => setTimeout(r, 30000));
      }
    };
    loop();
    return () => { cancelled = true; };
  }, [checkConnection]);

  useEffect(() => {
    const onOnline = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  // ─── Auto‐retry Countdown ──────────────────────────────────────
  useEffect(() => {
    if (!isOnline) {
      const timer = setInterval(() => {
        setRetryIn(prev => {
          if (prev <= 1) {
            checkConnection();
            return 10;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isOnline, checkConnection]);

  const handleRetry = () => checkConnection();


  // ─── Compute Container Background ───────────────────────────────
  const getBackgroundColor = () => {
    if (!isOnline) return "#ffe6e6";
    if (isSlow) return "#fff8e1";
    return undefined;
  };

  // browser–audio unlock workaround (using to unlock audio for the notification)
  useEffect(() => {
    const enableAudio = () => {
      // This enables audio context after user interaction
      const audio = new Audio();
      audio.play().catch(() => { });
      document.removeEventListener('click', enableAudio);
    };
    document.addEventListener('click', enableAudio, { once: true });
    return () => document.removeEventListener('click', enableAudio);
  }, []);

  // ─── EARLY RETURNS AFTER ALL HOOKS ───────────────────────────────────
  if (companySwitchLoading || loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", flexDirection: "column", gap: 3, }} >
        {/* Optimized Lottie Animation - Fixed jittering */}
        <Box sx={{
          width: 420,
          height: 420,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          willChange: "transform",
          perspective: 1000
        }}>
          <DotLottieReact
            src="https://lottie.host/3f202de2-cf4d-49b9-87f5-8136d321a1fd/tJ0qNGbvSd.lottie"
            loop
            autoplay
            speed={0.8}
            style={{
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              transform: "translateZ(0)",
              willChange: "transform"
            }}
          />
        </Box>
        <Typography variant="h5" fontWeight="bold"> Please wait... </Typography>
        <Typography variant="body2" color="text.secondary"> Loading, thank you for your patience. </Typography>
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", backgroundColor: getBackgroundColor() }} >
      {/* No‐Internet Overlay */}
      <AnimatePresence>
        {!isOnline && (
          <motion.div
            key="no-internet-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            style={{
              position: "fixed", inset: 0, zIndex: 2000,
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "linear-gradient(160deg, #071330 0%, #0c2461 45%, #1565c0 100%)",
              overflow: "hidden",
            }}
          >
            {/* Dot grid texture */}
            <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", opacity: 0.06, backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "28px 28px" }} />
            {/* Glow accents — gentle drift */}
            <motion.div
              animate={{ x: [0, 16, 0], y: [0, -12, 0] }}
              transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
              style={{ position: "absolute", top: "-15%", right: "-10%", width: 480, height: 480, borderRadius: "50%", background: "radial-gradient(circle, rgba(24,119,242,0.35) 0%, transparent 68%)", pointerEvents: "none" }}
            />
            <motion.div
              animate={{ x: [0, -14, 0], y: [0, 10, 0] }}
              transition={{ duration: 9, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
              style={{ position: "absolute", bottom: "-15%", left: "-15%", width: 420, height: 420, borderRadius: "50%", background: "radial-gradient(circle, rgba(8,85,168,0.4) 0%, transparent 68%)", pointerEvents: "none" }}
            />

            <motion.div
              role="alert"
              initial={{ opacity: 0, y: 24, scale: 0.94 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 12, scale: 0.96 }}
              transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1], delay: 0.05 }}
              style={{
                position: "relative", zIndex: 1,
                background: "rgba(255,255,255,0.98)",
                borderRadius: 20,
                textAlign: "center",
                width: "90%", maxWidth: 420,
                boxShadow: "0 24px 70px rgba(0,0,0,0.35)",
              }}
            >
              <Box sx={{ px: { xs: 3.5, sm: 5 }, py: { xs: 4.5, sm: 5.5 } }}>
                {/* Icon with pulse rings */}
                <Box sx={{ position: "relative", width: 92, height: 92, mx: "auto", mb: 3.5 }}>
                  <motion.div
                    initial={{ scale: 0, rotate: -20 }}
                    animate={{ scale: 1, rotate: 0 }}
                    transition={{ duration: 0.5, ease: [0.34, 1.56, 0.64, 1], delay: 0.2 }}
                    style={{
                      position: "absolute", inset: 0, borderRadius: "50%",
                      background: "#fef2f2", border: "1px solid #fecaca",
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}
                  >
                    <motion.div
                      animate={{ rotate: [0, -8, 8, -8, 0] }}
                      transition={{ duration: 2.4, repeat: Infinity, repeatDelay: 1.5, ease: "easeInOut" }}
                    >
                      <WifiOff sx={{ fontSize: 42, color: "#dc2626" }} />
                    </motion.div>
                  </motion.div>
                  {[0, 0.6].map((delay) => (
                    <motion.div
                      key={delay}
                      initial={{ scale: 1, opacity: 0.7 }}
                      animate={{ scale: 1.35, opacity: 0 }}
                      transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut", delay }}
                      style={{
                        position: "absolute", inset: -8, borderRadius: "50%",
                        border: "1.5px solid rgba(220,38,38,0.35)",
                      }}
                    />
                  ))}
                </Box>

                <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.35 }}>
                  <Typography sx={{ fontWeight: 800, fontSize: "1.3rem", color: "#0f172a", mb: 1, letterSpacing: "-0.3px" }}>
                    No Internet Connection
                  </Typography>
                </motion.div>
                <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.36, duration: 0.35 }}>
                  <Typography sx={{ color: "#64748b", fontSize: "0.92rem", lineHeight: 1.6, mb: 3.5 }}>
                    We can't reach the server right now. Check your connection — we'll keep trying automatically.
                  </Typography>
                </motion.div>

                {/* Countdown chip */}
                <motion.div
                  layout={false}
                  style={{ display: "inline-block" }}
                >
                  <Box sx={{
                    display: "inline-flex", alignItems: "center", gap: 1,
                    bgcolor: "#f0f9ff", border: "1px solid #bae6fd",
                    borderRadius: 5, px: 2, py: 0.8, mb: 3,
                  }}>
                    <CircularProgress size={14} thickness={5} sx={{ color: "#0369a1" }} />
                    <Typography sx={{ color: "#0369a1", fontSize: "0.82rem", fontWeight: 600 }}>
                      Retrying in {retryIn}s
                    </Typography>
                  </Box>
                </motion.div>

                <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.97 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<RefreshRoundedIcon />}
                    onClick={handleRetry}
                    sx={{
                      py: 1.4, borderRadius: 2, fontSize: "0.95rem", fontWeight: 700, textTransform: "none",
                      background: "linear-gradient(135deg, #1877F2 0%, #0A66C2 100%)",
                      boxShadow: "0 4px 16px rgba(24,119,242,0.3)",
                      "&:hover": { background: "linear-gradient(135deg, #0A66C2 0%, #0855A8 100%)", boxShadow: "0 6px 20px rgba(24,119,242,0.4)" },
                    }}
                  >
                    Try Now
                  </Button>
                </motion.div>
              </Box>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Layout */}
      {isOnline && (
        <Box sx={{ display: "flex" }}>
          <Navigation onLogout={handleLogout} connectionString={connectionString} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} appVersion={appVersion} />

          <Box component="main" sx={{ flexGrow: 1, pt: 8, minWidth: 0, }} >
            <CartProvider>
              <DispatchProvider>
                {!routeAllowed ? (
                  <InvalidRequestPage />
                ) : (
                <Routes>
                  {/* ─── V1 ─────────────────────────────── */}
                  <Route path="v1/inquiry" element={<InquiryForm_v1 connectionString={connectionString} />} />
                  <Route path="v1/inquiry-details" element={<InquiryDetails_v1 connectionString={connectionString} />} />
                  <Route path="v1/followup" element={<FollowUpPage_v1 connectionString={connectionString} />} />
                  <Route path="v1/userdetails" element={<UserDetailsPage_v1 connectionString={connectionString} />} />
                  <Route path="v1/usermaster" element={<UserMaster_v1 connectionString={connectionString} />} />
                  <Route path="v1/teamleaderdetails" element={<TeamLeaderDetails_v1 connectionString={connectionString} />} />
                  <Route path="v1/teamdetails" element={<TeamDetails_v1 connectionString={connectionString} />} />
                  {/*────────────────────────────────────────  */}
                  <Route path="v3/quatationDetail" element={<InquiryDetail connectionString={connectionString} />} />
                  <Route path="v3/quatationMaster" element={<QuotationMaster mode="add" connectionString={connectionString} />} />
                  <Route path="v3/editquatationMaster/:id" element={<QuotationMaster mode="edit" connectionString={connectionString} />} />
                  <Route path="v3/quatationMaster/:inquiryId" element={<QuotationMaster mode="inquiry" connectionString={connectionString} />} />
                  {/* ─── Dashboard & Core ─────────────────────────────── */}
                  <Route path="home" element={<Home2 connectionString={connectionString} />} />
                  <Route path="/company" element={<CompanyDetail connectionString={connectionString} drawerOpen={drawerOpen} />} />
                  <Route path="/newCompany" element={<CompanyMaster connectionString={connectionString} mode="add" />} />
                  <Route path="/editCompany/:id" element={<CompanyMaster connectionString={connectionString} mode="edit" />} />
                  <Route path="followup" element={<FollowUpPage connectionString={connectionString} />} />
                  <Route path="v3/followup" element={<FollowUpPageV3 connectionString={connectionString} />} />
                  <Route path="v2/inquiry" element={<InquiryForm connectionString={connectionString} />} />
                  {/* ─── User Management ──────────────────────────────── */}
                  <Route path="usermaster" element={<UserMaster connectionString={connectionString} />} />
                  <Route path="change-password" element={<ChangePassword connectionString={connectionString} />} />
                  <Route path="user-define-columns" element={<UserDefineColumns connectionString={connectionString} />} />
                  <Route path="AddOnCharges" element={<UserDefineCharges connectionString={connectionString} />} />
                  <Route path="/userdetails" element={<UserDetailsPage connectionString={connectionString} />} />
                  <Route path="v3/userdetails" element={<UserDetailsPage_v3 connectionString={connectionString} />} />
                  {/* ─── Inquiry Details ─────────────────────────────── */}
                  <Route path="v2/inquiry-details" element={<InquiryDetails connectionString={connectionString} />} />
                  <Route path="v4/inquiry-details" element={<InquiryDetailsV4 connectionString={connectionString} />} />
                  <Route path="reassignInquiryDetails" element={<ReassignInquiryDetails connectionString={connectionString} />} />
                  <Route path="v2/reassignInquiryDetails" element={<ReAssignInquiryDetails2 connectionString={connectionString} />} />
                  {/* ─── Team Management ──────────────────────────────── */}
                  <Route path="teamleaderdetails" element={<TeamLeaderDetails connectionString={connectionString} />} />
                  <Route path="teamdetails" element={<TeamDetails connectionString={connectionString} />} />
                  <Route path="v3/teamleaderdetails" element={<TeamLeaderDetails_v3 connectionString={connectionString} />} />
                  {/* ─── Complaint Module ─────────────────────────────── */}
                  <Route path="complain-details" element={<ComplainDetails connectionString={connectionString} />} />
                  <Route path="complainInsert" element={<ComplainForm mode="add" connectionString={connectionString} />} />
                  <Route path="edit-complainInsert" element={<ComplainForm mode="edit" connectionString={connectionString} />} />
                  <Route path="complain-followup" element={<ComplainFollowUp connectionString={connectionString} />} />
                  <Route path="v2/complain-followup" element={<ComplainFollowUpVersion2 connectionString={connectionString} />} />
                  <Route path="complain-reassign" element={<ReAssignComplaintDetails connectionString={connectionString} />} />
                  {/* ─── Key Management ──────────────────────────────── */}
                  <Route path="/Key-Option" element={<KeyOptions connectionString={connectionString} />} />
                  <Route path="/generate-key" element={<GenerateKey connectionString={connectionString} />} />
                  <Route path="/FileUpload" element={<FileUpload connectionString={connectionString} />} />
                  <Route path="/InsertData" element={<InsertClientData connectionString={connectionString} />} />
                  {/* ─── Printing Module ──────────────────────────── */}
                  <Route path="/PrintingUtilities" element={<PrintingUtilities connectionString={connectionString} />} />
                  {/* ─── Payments & Finance ──────────────────────────── */}
                  <Route path="/paymentFollowup" element={<SuccessFollowupPage connectionString={connectionString} />} />
                  <Route path="/receivable" element={<Receiveable connectionString={connectionString} />} />
                  <Route path="/receivable-v2" element={<ReceiveableV2 connectionString={connectionString} />} />
                  <Route path="/receivable-edit/:id" element={<ReceiveableV2 connectionString={connectionString} mode="edit" />} />
                  {/* <Route path="/receivable-v2" element={<ReceiveableV2 connectionString={connectionString} />} /> */}
                  <Route path="/receivable-details" element={<ReceivableDetails connectionString={connectionString} />} />
                  <Route path="/Payable" element={<Payable connectionString={connectionString} />} />
                  <Route path="/payable-v2" element={<PayableV2 connectionString={connectionString} />} />
                  <Route path="/payable-edit/:id" element={<PayableV2 connectionString={connectionString} mode="edit" />} />
                  <Route path="/payable-details" element={<PayableDetails connectionString={connectionString} />} />
                  {/* <Route path="/Vouchers" element={<Vouchers connectionString={connectionString} />} /> */}
                  <Route path="/Vouchers" element={<Vouchers connectionString={connectionString} drawerOpen={drawerOpen} />} />
                  <Route path="/voucher-edit/:id" element={<Vouchers connectionString={connectionString} drawerOpen={drawerOpen} mode="edit" />} />

                  <Route path="/voucherDetails" element={<VoucherDetails connectionString={connectionString} drawerOpen={drawerOpen} />} />
                  <Route path="/sale-invoice" element={<SaleInvoice connectionString={connectionString} />} />
                  <Route path="v2/sale-invoice" element={<SaleInvoice_v2 connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="v2/sale-invoice-prev-fy" element={<SaleInvoicePrevFY connectionString={connectionString} pdfString={pdfString} bookName="SALE" />} />
                  <Route path="v2/purchase-invoice-prev-fy" element={<SaleInvoicePrevFY connectionString={connectionString} pdfString={pdfString} bookName="PURC" />} />
                  <Route path="v3/sale-invoice" element={<SaleInvoice3 connectionString={connectionString} />} />
                  <Route path="/CreditNote" element={<CreditNote connectionString={connectionString} />} />
                  <Route path="v2/CreditNote" element={<CreditNotev2 connectionString={connectionString} />} />

                  {/* ─── Proforma Invoice ───────────────────────────── */}
                  <Route path="proforma-invoice" element={<ProformaInvoiceDetails connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="ProformaInvoiceMaster-stepper" element={<ProformaInvoiceMaster mode="add" connectionString={connectionString} />} />
                  <Route path="ProformaInvoiceMaster-stepper-proforma/:clientId" element={<ProformaInvoiceMaster mode="proforma" connectionString={connectionString} />} />
                  <Route path="ProformaInvoiceMaster-edit/:proformaInvoiceId" element={<ProformaInvoiceMaster mode="edit" connectionString={connectionString} />} />
                  {/* ─── Candidate Management ───────────────────────────── */}
                  {/* <Route path="/ClentDetails" element={<ClientDetail connectionString={connectionString} />} /> */}
                  {/* <Route path="/client-master-webview" element={<ClientMasterWrapper connectionString={connectionString} />} /> */}
                  <Route path="/CandidateMaster" element={<CandidateMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/editCandidate/:id" element={<CandidateMaster mode="edit" connectionString={connectionString} />} />
                  <Route path="/CandidateDetails" element={<CandidateDetails connectionString={connectionString} />} />
                  <Route path="/insertCandidates" element={<InsertCandidates connectionString={connectionString} />} />
                  {/* ─── Client Management ───────────────────────────── */}
                  <Route path="/ClentDetails" element={<ClientDetail connectionString={connectionString} />} />
                  <Route path="/newClient" element={<ClientMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/insertClient" element={<InsertClient connectionString={connectionString} />} />
                  <Route path="/client-master-webview" element={<ClientMasterWrapper connectionString={connectionString} />} />
                  <Route path="/editClient/:id" element={<ClientMaster mode="edit" connectionString={connectionString} />} />
                  <Route path="v2/ClentDetails" element={<ClientDetail2 connectionString={connectionString} />} />
                  <Route path="/AccGrpDetails" element={<AccGrpDetails connectionString={connectionString} />} />
                  <Route path="/AccGrpMaster" element={<AccGrpMaster connectionString={connectionString} />} />
                  <Route path="/editAccGrp/:id" element={<AccGrpMaster mode="edit" connectionString={connectionString} />} />
                  {/* ─── Consignee Management ───────────────────────────── */}
                  <Route path="/consignee-details" element={<ConsigneeDetails connectionString={connectionString} />} />
                  <Route path="/consignee-master" element={<ConsigneeMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/edit-consignee/:conId/:partyId" element={<ConsigneeMaster mode="edit" connectionString={connectionString} />} />
                  {/* <Route path="/edit-consignee/:conId" element={<ConsigneeMaster mode="edit" connectionString={connectionString} />} /> */}
                  <Route path="v2/consignee-details" element={<ConsigneeDetails2 connectionString={connectionString} />} />
                  {/* ─── Currency Management ─────────────────────────── */}
                  <Route path="/currencyDetail" element={<CurrencyDetail connectionString={connectionString} />} />
                  <Route path="/currencyMaster" element={<CurrencyMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/editCurrencyMaster/:id" element={<CurrencyMaster mode="edit" connectionString={connectionString} />} />
                  <Route path="v2/currencyDetail" element={<CurrencyDetail2 connectionString={connectionString} />} />
                  {/* ─── Quotation Management ────────────────────────── */}
                  <Route path="/QuatationDetails" element={<QuotationDetail connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="/quotation-master" element={<QuotationMaster connectionString={connectionString} />} />
                  {/* ─── Go Down Component ───────────────────────────────  */}
                  <Route path="/godownDetail" element={<GoDownDetail connectionString={connectionString} />} />
                  <Route path="/godownMaster" element={<GodownMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/editGodownMaster/:id" element={<GodownMaster mode="edit" connectionString={connectionString} />} />
                  {/* ─── HSN Component ───────────────────────────────  */}
                  <Route path="/hsnDetail" element={<HsnDetail connectionString={connectionString} />} />
                  <Route path="/hsnMaster" element={<HsnMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/editHsnMaster/:id" element={<HsnMaster mode="edit" connectionString={connectionString} />} />
                  {/* ─── Unit Component ───────────────────────────────  */}
                  <Route path="/unitDetail" element={<UnitDetail connectionString={connectionString} />} />
                  <Route path="/unitMaster" element={<UnitMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/editUnitMaster/:id" element={<UnitMaster mode="edit" connectionString={connectionString} />} />
                  {/* ─── Product Group Component ───────────────────────────────  */}
                  <Route path="/proGroupDetail" element={<ProdGroupDetail connectionString={connectionString} />} />
                  <Route path="/proGroupMaster" element={<ProGroupMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/editProGroupMaster/:id" element={<ProGroupMaster mode="edit" connectionString={connectionString} />} />
                  <Route path="v2/proGroupDetail" element={<ProdGroupDetail2 connectionString={connectionString} />} />
                  {/* ─── Product Component ───────────────────────────────  */}
                  <Route path="/productDetail" element={<ProductDetail connectionString={connectionString} />} />
                  <Route path="/productMaster" element={<ProductMaster mode="add" connectionString={connectionString} />} />
                  <Route path="insertProduct" element={<InsertProduct connectionString={connectionString} />} />
                  <Route path="/editProductMaster/:id" element={<ProductMaster mode="edit" connectionString={connectionString} />} />
                  <Route path="v2/productDetail" element={<ProductDetail2 connectionString={connectionString} />} />
                  {/* <Route path="v2/productDetail" element={<ProductDetail2 connectionString={connectionString} />} /> */}
                  <Route path="/BOM" element={<MultiLevelBOMForm connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/v2/orderDetail-stepper" element={<OrderDetail connectionString={connectionString} pdfString={pdfString} />} />
                  {/* Order Stepper */}
                  <Route path="v3/orderMaster-stepper" element={<OrderMaster mode="add" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="v3/orderMaster-stepper-ref" element={<OrderMaster mode="order" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="v3/orderMaster-edit/:SOAutoID" element={<OrderMaster mode="edit" connectionString={connectionString} />} />
                  {/* challan Stepper */}
                  <Route path="v3/challanMaster-stepper" element={<ChallanMaster mode="add" connectionString={connectionString} />} />
                  <Route path="v3/challanMaster-edit/:id" element={<ChallanMaster mode="edit" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="v3/challanMaster-stepper-ref/:clientId" element={<ChallanMaster mode="ref" connectionString={connectionString} />} />
                  {/* Invoice Stepper */}
                  <Route path="v3/InvoiceMaster-stepper" element={<InvoiceMaster mode="add" connectionString={connectionString} />} />
                  <Route path="v3/InvoiceMaster-stepper-ref/:clientId" element={<InvoiceMaster mode="ref" connectionString={connectionString} />} />
                  <Route path="v3/InvoiceMaster-edit/:saleInvoiceId" element={<InvoiceMaster mode="edit" connectionString={connectionString} />} />
                  {/* ─── Order Section Component ───────────────────────────────  */}

                  <Route path="/orderDetail" element={<OrderDetails connectionString={connectionString} />} />
                  <Route path="v2/orderDetail" element={<OrderDetails_v2 connectionString={connectionString} />} />
                  <Route path="/cart-page" element={<CartPage connectionString={connectionString} />} />
                  <Route path="/checkout-page" element={<CheckoutPage connectionString={connectionString} />} />
                  <Route path="/orderconfirmation/:orderId" element={<OrderConfirmation connectionString={connectionString} />} />
                  <Route path="/View-Order" element={<MyOrders connectionString={connectionString} />} />

                  {/*  */}
                  <Route path="/Order/:SOAutoID" element={<ViewOrderPage connectionString={connectionString} />} />
                  <Route path="/order-dispatch" element={<OrdersAdmin connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="/Order-Admin/:clientId" element={<DispatchPage connectionString={connectionString} />} />
                  <Route path="/dispatch-cart" element={<DispatchCart connectionString={connectionString} />} />

                  {/*  PURCHASE ORDER */}
                  <Route path="/purchase-orderDetails" element={<PurchaseOrderDetails connectionString={connectionString} pdfString={pdfString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-OrderMaster-stepper" element={<PurchaseOrderMaster mode="add" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-OrderMaster-stepper-ref" element={<PurchaseOrderMaster mode="order" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-OrderMaster-edit/:SOAutoID" element={<PurchaseOrderMaster mode="edit" connectionString={connectionString} />} />

                  {/* PURCHASE CHALLAN */}

                  <Route path="/Purchase-ChallanDetails" element={<PurcDispatchDetails connectionString={connectionString} pdfString={pdfString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-ChallanMaster-stepper" element={<PurcDispatchMaster mode="add" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-ChallanMaster-stepper-ref/:clientId" element={<PurcDispatchMaster mode="ref" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-ChallanMaster-edit/:SOAutoID" element={<PurcDispatchMaster mode="edit" connectionString={connectionString} />} />

                  <Route path="/Purchase-InvoiceDetails" element={<PurchaseInvoiceDetails connectionString={connectionString} pdfString={pdfString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-InvoiceMaster-stepper" element={<PurcInvoiceMaster mode="add" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-InvoiceMaster-stepper-ref/:clientId" element={<PurcInvoiceMaster mode="ref" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/Purchase-InvoiceMaster-edit/:SOAutoID" element={<PurcInvoiceMaster mode="edit" connectionString={connectionString} />} />

                  {/* Credit Note */}

                  <Route path="/CreditNote-Details" element={<CreditNoteDetails connectionString={connectionString} pdfString={pdfString} />} />
                  {/* Order Stepper */}
                  <Route path="/CreditNote-Master-stepper" element={<CreditNoteMaster mode="add" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/CreditNote-Master-stepper-ref/:clientId" element={<CreditNoteMaster mode="ref" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/CreditNote-Master-edit/:SOAutoID" element={<CreditNoteMaster mode="edit" connectionString={connectionString} />} />

                  {/* Debit Note */}
                  <Route path="/DebitNote-Details" element={<DebitNoteDetails connectionString={connectionString} pdfString={pdfString} />} />
                  {/* Order Stepper */}
                  <Route path="/DebitNote-Master-stepper" element={<DebitNoteMaster mode="add" connectionString={connectionString} />} />
                  {/* Order Stepper */}
                  <Route path="/DebitNote-Master-stepper-ref/:clientId" element={<DebitNoteMaster mode="ref" connectionString={connectionString} />} />
                  {/* Order Stepper */}e
                  <Route path="/DebitNote-Master-edit/:saleInvoiceId" element={<DebitNoteMaster mode="edit" connectionString={connectionString} />} />
                  <Route path="/Test-OrderMaster-stepper" element={<OrderTestMaster connectionString={connectionString} />} />

                  {/*  Task */}

                  <Route path="/Task" element={<TaskDetail connectionString={connectionString} />} />
                  <Route path="/TaskMaster" element={<TaskMaster mode="add" connectionString={connectionString} />} />
                  <Route path="/Task-ReAssign" element={<TaskReAssign mode="ref" connectionString={connectionString} />} />
                  <Route path="/EwayBill" element={<EwayBill connectionString={connectionString} />} />
                  <Route path="/EInvoice" element={<EInvoice connectionString={connectionString} />} />

                  {/*  Store */}
                  <Route path="/store-details" element={<StoreDetails connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="/store-master" element={<StoreMaster connectionString={connectionString} mode="add" />} />
                  <Route path="/store-master-edit/:id" element={<StoreMaster connectionString={connectionString} mode="edit" />} />

                  <Route path="/SeriesMaster" element={<SeriesMaster connectionString={connectionString} />} />

                  <Route path="/ledger-report" element={<LedgerDetails connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="/stock-report" element={<AccountReports connectionString={connectionString} pdfString={pdfString} groupFilter={["stock"]} title="Stock Reports" />} />
                  <Route path="/mis-report" element={<AccountReports connectionString={connectionString} pdfString={pdfString} groupFilter={["mis_sale"]} title="MIS Sale Reports" />} />
                  <Route path="/mis-purchase-report" element={<AccountReports connectionString={connectionString} pdfString={pdfString} groupFilter={["mis_purchase"]} title="MIS Purchase Reports" />} />
                  <Route path="/gst-reports" element={<AccountReports connectionString={connectionString} pdfString={pdfString} groupFilter={["gst_reports"]} title="GST Reports" />} />
                  <Route path="/account-report" element={<AccountReports connectionString={connectionString} pdfString={pdfString} groupFilter={["ledger"]} title="Account Reports" />} />

                  <Route path="/consigner" element={<ConsignerMaster connectionString={connectionString} pdfString={pdfString} mode="add" />} />
                  <Route path="/consigner-edit" element={<ConsignerMaster connectionString={connectionString} pdfString={pdfString} mode="edit" />} />
                  <Route path="/OSandODsale-report" element={<OSandODSaleReport connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="/OSandODpurc-report" element={<OSandODPurcReport connectionString={connectionString} pdfString={pdfString} />} />
                  <Route path="/OSandOD-bills-report" element={<AccountReports connectionString={connectionString} pdfString={pdfString} groupFilter={["os_od_sale", "os_od_purc"]} title="OS Reports" />} />
                  <Route path="/BankCashPosting" element={<BankCashPosting connectionString={connectionString} />} />


                  {/* Configure */}
                  <Route path="/configure" element={<ConfigureModule connectionString={connectionString} />} />
                  <Route path="/pricelist" element={<PriceListMaster connectionString={connectionString} />} />
                </Routes>
                )}
              </DispatchProvider>
            </CartProvider>
          </Box>
        </Box>
      )}

      {/* Slow‐connection Snackbar */}
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)} TransitionComponent={(props) => <Slide {...props} direction="up" />} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} >
        <Alert severity="warning" variant="filled"> Slow or Weak Connection </Alert>
      </Snackbar>
    </Box>
  );
}